
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.29474 5.29501C8.90175 5.68836 8.90175 6.3261 9.29474 6.71945L14.5705 12L9.29474 17.2805C8.90175 17.6739 8.90175 18.3116 9.29474 18.705C9.68774 19.0983 10.3249 19.0983 10.7179 18.705L16.7053 12.7122C17.0982 12.3189 17.0982 11.6811 16.7053 11.2878L10.7179 5.29501C10.3249 4.90166 9.68774 4.90166 9.29474 5.29501Z","fill":"white"}})])
          )
        }
      }
    